import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {action, makeAutoObservable, observable} from "mobx";
import {PlayedGames, RequestState} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IUserStore} from "data/stores/user/user.store";
import {includes} from "lodash";
import {ChangeEvent} from "react";

interface ITermsFormElement extends HTMLFormElement {
	terms: HTMLInputElement;
}

export interface IPlayedGamesController extends ViewController {
	get i18n(): ILocalizationStore;
	get visibleModal(): boolean;
	get isSubmitDisabled(): boolean;
	get isCountryUS(): boolean;

	handleFormOnChange: (event: ChangeEvent<ITermsFormElement>) => void;
	onAcceptTerms: () => void;
}

@injectable()
export class PlayedGamesController implements IPlayedGamesController {
	@observable _requestState: RequestState = RequestState.IDLE;
	@observable _terms: boolean = false;

	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get visibleModal() {
		return !includes(this._userStore.user?.playedGames, PlayedGames.Fantasy);
	}

	get isSubmitDisabled() {
		return !this._terms;
	}

	get isCountryUS(): boolean {
		return this._userStore.isCountryUS;
	}

	@action handleFormOnChange = (event: ChangeEvent<ITermsFormElement>) => {
		const {terms} = event.currentTarget;

		this._terms = terms.checked;
	};

	onAcceptTerms = () => {
		void this._userStore.userPlayedGames({game: PlayedGames.Fantasy});
	};

	dispose() {
		return;
	}

	init(param: void) {
		return;
	}
}
